import {
  RouteRecordRaw, RouterOptions,
  createRouter, createWebHistory, createWebHashHistory
} from 'vue-router';

import Config from '@constant/config';
import { RouterEnum } from '@interface/public';

export const RouterList: RouteRecordRaw[] = [ // 路由列表
  {
    path: RouterEnum.Root,
    redirect: Config.Page.default,
    name: '根'
  },
  {
    path: RouterEnum.Index,
    redirect: Config.Page.default,
    name: '主页'
  },
  {
    path: RouterEnum.SSO,
    redirect: Config.Page.default,
    name: 'SSO',
    component: () => import('@template/sso/index.vue'),
    children: [
      {
        path: RouterEnum.SSOIndex,
        name: 'SSO-主页',
        component: () => import('@template/sso/index/index.vue')
      },
      {
        path: RouterEnum.Register,
        redirect: Config.Page.default,
        // name: '注册',
        // component: () => import('@template/sso/register/register.vue')
      },
      {
        path: RouterEnum.Login,
        redirect: Config.Page.default,
        // name: '登录',
        // component: () => import('@template/sso/login/login.vue')
      },
      {
        path: RouterEnum.Logout,
        name: '退出登录',
        component: () => import('@template/sso/logout/logout.vue')
      },
      {
        path: RouterEnum.Replenish,
        name: '完善信息',
        component: () => import('@template/sso/replenish/replenish.vue')
      },
      {
        path: RouterEnum.Back,
        name: '返回',
        component: () => import('@template/sso/back/back.vue')
      },
      {
        path: RouterEnum.Cancel,
        name: '用户注销',
        component: () => import('@template/sso/cancel/cancel.vue')
      },
      {
        path: RouterEnum.StopCancel,
        name: '终止注销',
        component: () => import('@template/sso/stopCancel/stopCancel.vue')
      },
      
      // 渠道
      {
        path: RouterEnum.ChannelWeChat,
        name: '渠道-微信',
        component: () => import('@template/sso/channel/channelWeChat.vue')
      }
    ]
  },
  {
    path: RouterEnum.All,
    redirect: Config.Page.default,
    name: '其他'
  }
];

/**
 * 路由
 */
export default createRouter({
  history: $ENV.isProduction
    ? createWebHistory('/')
    : createWebHashHistory('/'),
  routes: RouterList
} as RouterOptions);
